import React from 'react';
import { resultsData } from '../data/mock';
import { CheckCircle, Award, Heart, Compass, Star } from 'lucide-react';

const iconMap = {
  CheckCircle,
  Award,
  Heart,
  Compass,
  Star
};

const Results = () => {
  return (
    <section id="results" className="py-24 bg-purple-100/60 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-64 h-64 bg-[#7ed321]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-[#6b2d7b]/10 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#6b2d7b] mb-4">
            {resultsData.title}
          </h2>
          <p className="text-xl text-slate-600">
            {resultsData.subtitle}
          </p>
        </div>

        {/* Results Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {resultsData.results.map((result, index) => {
            const IconComponent = iconMap[result.icon];
            return (
              <div
                key={index}
                className="group text-center p-6 rounded-2xl bg-slate-50 hover:bg-[#6b2d7b] transition-all duration-300 hover:shadow-lg hover:shadow-[#6b2d7b]/20 hover:-translate-y-1"
              >
                <div className="w-16 h-16 rounded-full bg-[#7ed321]/20 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#7ed321] transition-colors duration-300">
                  <IconComponent className="w-8 h-8 text-[#6b2d7b] group-hover:text-[#2d1b38] transition-colors duration-300" />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-white transition-colors duration-300">
                  {result.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed group-hover:text-white/80 transition-colors duration-300">
                  {result.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Results;
